import * as React from "react";
import classnames from "classnames";
import { LimeWrapper } from "@grandvisionhq/lib-lime";
import { useSelector } from "@grandvisionhq/state";
import { useTransitionColor } from "../../../../../../hooks/hooks/use-transition-color.js";
import { useRxConfiguratorSlots } from "../../../../../../slots/slots/context.js";
import "../../../../../../state/state/actions.js";
import "../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../state/bundles/state/bundles/reducer.js";
import { getSelectedFrame, getSelectedAddOn, getFrameImage } from "../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../state/products/state/products/selectors.js";
import "../../../../../../state/products/state/products/reducer.js";
import "@grandvisionhq/lib-lime/css";
/* empty css                */
const FrameImage = ({ className }) => {
  const transitionColor = useTransitionColor();
  const { Slots } = useRxConfiguratorSlots();
  const frame = useSelector(getSelectedFrame);
  const selectedAddOn = useSelector(getSelectedAddOn);
  const frameImageUrl = useSelector(
    (s) => getFrameImage(s, { width: 592 })?.url
  );
  const altText = frame?.title || "";
  return /* @__PURE__ */ React.createElement("div", { className: classnames("frame-image", className) }, frame && frameImageUrl && Slots.ProductImage ? /* @__PURE__ */ React.createElement(
    Slots.ProductImage,
    {
      className: "frame-image__product",
      imageUrl: frameImageUrl,
      altText
    },
    transitionColor && /* @__PURE__ */ React.createElement(
      LimeWrapper,
      {
        frameUPC: frame.sku,
        frameSrc: frameImageUrl,
        lensColor: transitionColor,
        transitionType: selectedAddOn?.transitionType?.toLowerCase()
      }
    )
  ) : null);
};
export {
  FrameImage
};
//# sourceMappingURL=FrameImage.js.map
